interface CanAccessNewBookingPaymentPageParams {
  isGroupBooking: boolean
  isFlagEnabled: boolean
  isGroupPaymentFlagEnabled: boolean
}

export function canAccessNewBookingPaymentPage({
  isGroupBooking,
  isFlagEnabled,
  isGroupPaymentFlagEnabled,
}: CanAccessNewBookingPaymentPageParams): boolean {
  return isGroupBooking ? isGroupPaymentFlagEnabled : isFlagEnabled
}
